import sendGetGameStartedRequest from "../services/User/send-get-game-started-request";
import sendLoginRequest from "../services/User/send-login-request";
import sendRegisterRequest from "../services/User/send-register-request";
import sendResetGameRequest from "../services/User/send-reset-game-request";
import sendStartGameRequest from "../services/User/send-start-game-request";
import { loginRequestObject, responseObject, responseStartGame } from "./types/class-user.types";

export class User {
    private _userId: string;
    private _username: string;
    private _password: string;

    public constructor(userId: string, username: string, password: string) {
        this._userId = userId;
        this._username = username;
        this._password = password;
    }

    // get userId
    public get userId(): string | undefined {
        return this._userId;
    }

    // create new user
    public async createNewUser(username: string, password: string): Promise<responseObject | null> {
        const result: responseObject | null = await sendRegisterRequest(username, password);

        if (!result) {
            return null;
        }

        if (result.status === 400) {
            const statusMessage: responseObject = {
                status: result.status,
                error: "User already exists with the filled in credentials, please try again.",
                data: null,
            };
            return statusMessage;
        }

        // set ready for auto login after account creation

        return null;

        // Sets the userId inside the property of this class, which is then used in setLoggedInUser()
        // this._userId = "result.data.insertId";
    }

    // // get an object of userdata by a user's userId
    // public async getUserDataById(userId: string): Promise<object> | null {
    //     const user: string = CookieManager.getUserCookie();

    //     if (!user) {
    //         return null;
    //     }

    //     // query for userdata by userId
    //     const userData: object = { userId: userId };

    //     return userData;
    // }

    public get loggedInUser(): object | null {
        const userId: object = CookieManager.getUserCookie();

        if (!userId) {
            return null;
        }

        return userId;
    }

    // set the user session / login
    public async setloggedInUser(): Promise<loginRequestObject> {
        const result: responseObject | null = await sendLoginRequest(this._username, this._password);

        if (!result) {
            const statusMessage: loginRequestObject = {
                error: "Something went wrong when trying to login.",
            };
            return statusMessage;
        }

        if (result.status !== 200) {
            const statusMessage: loginRequestObject = {
                status: result.status,
                error: "invalid username or password",
            };
            return statusMessage;
        }

        this._userId = result.data[0].userId;
        CookieManager.setUserCookie(this._userId);

        console.log("Succesfull login!");

        const statusMessage: loginRequestObject = {
            status: result.status,
            success: "Success!",
        };
        return statusMessage;
    }

    // remove the user session / logout
    public removeLoggedInUser(): void {
        CookieManager.removeUserCookie();
    }

    public async startGameForUser(): Promise<void> {
        const result: responseStartGame | undefined = await sendStartGameRequest(this._userId);

        if (!result || result.status === 400) {
            console.error("starting the game failed");
            return;
        }
    }

    public async resetGameProgressForUser(): Promise<void> {
        const result: responseStartGame | undefined = await sendResetGameRequest(this._userId);

        if (!result || result.status === 400) {
            console.error("Resetting the user's game progress failed");
            return;
        }
    }

    public async getGameStartedStatus(): Promise<boolean> {
        const result: boolean = await sendGetGameStartedRequest(this._userId);

        if (result === false) {
            return false;
        }

        return true;
    }
}

// Seperate class to manage cookies and sessions.
// source: https://www.youtube.com/watch?v=8tL5P-RtAH0&ab_channel=CodeWithBubb
export class CookieManager {
    public static setUserCookie(userId: string): void {
        document.cookie = `userId=${userId}`;
    }

    public static getUserCookie(): object {
        const cookiesInObjects: object | [object] | null = document.cookie
            .split(";")
            .map((cookie) => cookie.split("="))
            .reduce(
                (accumulator, [key, value]) => ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }),
                {}
            );

        console.log(cookiesInObjects);

        return cookiesInObjects;
    }

    public static removeUserCookie(): void {
        const userCookie: object = this.getUserCookie();

        if (userCookie) {
            document.cookie = "userId=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            console.log("removed userId cookie");
            return;
        } else {
            console.log("userId cookie is empty or doesn't exist.");
            return;
        }
    }
}
